jQuery(function($) {

	function isScrolledIntoView(elem) {

		if ($(elem).length) {
			
			var docViewTop = $(window).scrollTop();
			var docViewBottom = docViewTop + $(window).height();
	
			var elemTop = $(elem).offset().top;
			var elemBottom = elemTop + $(elem).height();

			var elemMidline = ((elemBottom - elemTop) / 2) + elemTop;

			// console.log('docViewTop: ' + docViewTop);
			// console.log('docViewBottom: ' + docViewBottom);
			// console.log('elemTop: ' + elemTop);
			// console.log('elemBottom: ' + elemBottom);
			// console.log('elemMidline: ' + elemMidline);
			// console.log('in view: ' + ((elemBottom <= docViewBottom) && (elemTop >= docViewTop)));
			// console.log('in viewMidline: ' + ((elemMidline <= docViewBottom) && (elemMidline >= docViewTop)));
			// console.log('------');
	
			return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
		}
		return null;
	}

	var animate = false;

	$(window).scroll(function() {
		
		// console.log('scroll');

		if(isScrolledIntoView(".brand-carousel .owl-carousel") === true && !animate) {
			$(".brand-carousel .owl-carousel").trigger('play.owl.autoplay');
			animate = true;
			// console.log('Starting animation');
		} else if(isScrolledIntoView(".brand-carousel .owl-carousel") === false && animate) {
			$(".brand-carousel .owl-carousel").trigger('stop.owl.autoplay');
			animate = false;
			// console.log('Stopping animation');
		}
		
		if(isScrolledIntoView(".brands-list-carousel .owl-carousel") === true && !animate) {
			$(".brands-list-carousel .owl-carousel").trigger('play.owl.autoplay');
			animate = true;
			// console.log('Starting animation');
		} else if(isScrolledIntoView(".brands-list-carousel .owl-carousel") === false && animate) {
			$(".brands-list-carousel .owl-carousel").trigger('stop.owl.autoplay');
			animate = false;
			// console.log('Stopping animation');
		}
	});

	handleCarousels();
	handleScrolltoSection();
	handleHeader();
	handleTablesPagination();
	handleDocumentsCategoriesFilter();
	handleDocumentsYearFilter();
	handleDocumentsSearchFilter();
	handleMemberLightbox();
	handleMobileMenu();
	handleBanner();
	handleSubscribeForm();
	handleMap();
	handleScrollDownLinks();
	handleFadeInElements();
	handleFullPage();
	handleNews();

	// $.scrollify({
	// 	section : ".page-scrollify",
	// 	setHeights : false,
	// });

	function handleNews(){
		
		$('body').on('click', '.trigger-load-more-news', function (e) {
			
			if ($(this).hasClass('ajax-loading')) {
				return;
			}

			var el = $(this);

			el.addClass('ajax-loading');

			$.ajax({
				type: "post",
				dataType: "json",
				url: ajax_object.ajaxurl,
				data: {
					currentPage: $('.target-load-more-news').attr('data-current-page'),
					_ajax_nonce: ajax_object.ajax_nonce,
					action: 'handleLoadMoreNews'
				},
			})
			.done(function(response) {
				if (response.error) {
					alert('something went wrong');
				} else {
					$('.target-load-more-news').append(response.html);
					$('.target-load-more-news').attr('data-current-page', response.newPage );
					if(response.finish){
						$('.trigger-load-more-news').text('No More News').addClass('no-decoration').addClass('inactive').removeClass('.trigger-load-more-news');
					}
				}
			})
			.fail(function(jqXHR, textStatus, errorThrown) {
				if (jqXHR.readyState == 0 || jqXHR.status == 0) {
					return;
				} else {
					alert('something went wrong');
				}
			})
			.always(function() {
				el.removeClass('ajax-loading');
			});
			
		});
	}

	function handleMap(){
		if ($('#office-mapping').length){
			$( "#office-mapping area" ).hover(
				function() {
					var target = $(this).attr('data-office');
					$(target).fadeIn();
				}, function() {
					$('.popup-office').hide();
				}
			);
		}
	}

	function handleSubscribeForm(){
		if ($('#form-subscribe').length){

			$("#form-subscribe").validate({
				errorClass: 'is-invalid',
				validClass: '',
				errorElement: "span",
				focusInvalid: false,
				rules: {
					'form-name': {
						required: true,
						maxlength: 200
					},
					'form-surname': {
						required: true,
						maxlength: 200
					},
					'form-email': {
						required: true,
						email: true,
						maxlength: 200
					},
				},
				messages: {
					'form-name': {
						required: "Please enter your first name",
					},
					'form-surname': {
						required: "Please enter your surname",
					},
					'form-email': {
						required: "Please enter your email",
						email: "Please enter a valid email",
					},
				},
				errorPlacement: function(error, element) {
					element.parent().append(error);
				},
				invalidHandler: function(elem, validator) {
					var errors = validator.numberOfInvalids();
					if (errors) {                    
						validator.errorList[0].element.focus();
					}
				},
				submitHandler: function(form) {

					handleSubscribeFormSubmit();
				}
			});
		}
	}

	function handleSubscribeFormSubmit(){
		
		if ($('#form-subscribe').hasClass('ajax-loading')) {
			return;
		}
		$('#form-subscribe .feedback').html('');

		$('#form-subscribe').addClass('ajax-loading');

		$.ajax({
			type: "post",
			dataType: "json",
			url: ajax_object.ajaxurl,
			data: {
				form: $('#form-subscribe').serialize(),
				_ajax_nonce: ajax_object.ajax_nonce,
				action: 'handleSubscribeFormSubmit'
			},
		})
		.done(function(response) {
			if (response.error) {
				$('#form-subscribe .feedback').html(response.message);
			} else {
				$('#form-subscribe').parent().html(response.html);
			}
		})
		.fail(function(jqXHR, textStatus, errorThrown) {
			if (jqXHR.readyState == 0 || jqXHR.status == 0) {
				return;
			} else {
				alert('something went wrong');
			}
		})
		.always(function() {
			$('#form-subscribe').removeClass('ajax-loading');
		});
	}


	function handleBanner(){

		if($('#banner').length){
			var bannerHeight = $('#banner').height();
			$('#header').css({top: bannerHeight});
			$('#main').css({paddingTop: bannerHeight - 5  });
		}

	}

	function handleMobileMenu(){

		$('body').on('click', '#trigger-menu-mobile', function (e) {
			
			if($('#header').hasClass('mobile-open')){
				$('#header').removeClass('mobile-open');
			}else{
				$('#header').addClass('mobile-open');
			}
		});
	}

	function handleMemberLightbox(){
		$(".trigger-member-lightbox").colorbox({
			inline: true,
			href: "#target-member-lightbox",
			transition: 'fade',
			maxWidth: "1100px",
			width: "90%",
			// height: "496px",
			speed: 100,
			// closeButton: false,
			onLoad: function(e) {
				$('#target-member-lightbox .lightbox-wrapper').html('').addClass('loading');
				var memberId = $(this).attr('data-memberID');
				$.ajax({
					type: "post",
					dataType: "json",
					url: ajax_object.ajaxurl,
					data: {
						memberId: memberId,
						_ajax_nonce: ajax_object.ajax_nonce,
						action: 'handleLightboxMemberRequest'
					},
				})
				.done(function(response) {
					if (response.error) {
						alert(response.message);
					} else {
						$('#target-member-lightbox .lightbox-wrapper').html(response.html).hide().fadeIn();
						$('#target-member-lightbox .lightbox-wrapper').removeClass('loading');
					}
				})
				.fail(function(jqXHR, textStatus, errorThrown) {
					if (jqXHR.readyState == 0 || jqXHR.status == 0) {
						return;
					} else {
						alert('something went wrong');
					}
				})
				.always(function() {
					$.colorbox.resize()
				});
			},
		});
	}

	function handleDocumentsSearchFilter(){

		$('html').on('submit', '#form-asx-search', function (e) {

			e.preventDefault();

			var section = $(this).closest('.asx-documents-wrapper');
			var table = section.find('table');

			if(table.hasClass('ajax-loading')){
				return;
			}

			$('#form-asx-search-text').removeClass('form-error');
			var searchString = $('#form-asx-search-text').val();

			if(!searchString){
				$('#form-asx-search-text').addClass('form-error');
				return;
			}

			table.attr('data-year', '');
			table.attr('data-searchString', searchString);
			var page = 1;

			handleTablesPaginationRequest(section, page, true);

		});
	}
	
	function handleDocumentsYearFilter(){

		$('html').on('click', '.trigger-document-year-filter', function (e) {

			e.preventDefault();
			var parent = $(this).closest('li');

			if(parent.hasClass('active')){
				return;
			}

			var section = $(this).closest('.asx-documents-wrapper');
			var table = section.find('table');

			if(table.hasClass('ajax-loading')){
				return;
			}

			$(this).closest('ul').find('li').removeClass('active');
			parent.addClass('active');
			
			var year = $(this).attr('data-year');
			table.attr('data-year', year);
			table.attr('data-searchString', '');
			var page = 1;

			handleTablesPaginationRequest(section, page, true);

		});
	}
	
	function handleDocumentsCategoriesFilter(){

		$('html').on('click', '.trigger-document-category', function (e) {

			e.preventDefault();
			var parent = $(this).closest('li');

			if(parent.hasClass('active')){
				return;
			}

			var section = $(this).closest('.key-documents-wrapper');
			var table = section.find('table');

			if(table.hasClass('ajax-loading')){
				return;
			}

			$(this).closest('ul').find('li').removeClass('active');
			parent.addClass('active');
			
			var categoryId = $(this).attr('data-category');
			table.attr('data-category', categoryId);
			var page = 1;

			handleTablesPaginationRequest(section, page, true);

		});
	}

	function handleTablesPagination(){

		$('html').on('click', '.trigger-pagination', function (e) {

			e.preventDefault();
			var parent = $(this).closest('li');

			if(parent.hasClass('active')){
				return;
			}

			var section = $(this).closest('.table-paginated-wrapper');
			var table = section.find('table');

			if(table.hasClass('ajax-loading')){
				return;
			}

			$(this).closest('ul').find('li').removeClass('active');
			parent.addClass('active');
			
			var page = $(this).attr('data-page');

			handleTablesPaginationRequest(section, page, false);

		});
	}

	function handleTablesPaginationRequest(section, page, resetPagination){

		var table = section.find('table');
		var type = table.attr('data-type');
		var category = table.attr('data-category');
		var year = table.attr('data-year');
		var searchString = table.attr('data-searchString');

		if(!category){
			category = '';
		}
		if(!year){
			year = '';
		}
		if(!searchString){
			searchString = '';
		}

		table.addClass('ajax-loading');

		$.ajax({
			type: "post",
			dataType: "json",
			url: ajax_object.ajaxurl,
			data: {
				type: type,
				category: category,
				year: year,
				searchString: searchString,
				page: page,
				resetPagination: resetPagination ? 1 : 0,
				_ajax_nonce: ajax_object.ajax_nonce,
				action: 'handleTablesPaginationRequest'
			},
		})
		.done(function(response) {
			if (response.error) {
				alert(response.message);
			} else {
				table.find('tbody').html(response.html);

				if(resetPagination){
					section.find('.table-pagination').remove();
					section.find('.table-wrapper').after(response.pagination);
				}
			}
		})
		.fail(function(jqXHR, textStatus, errorThrown) {
			if (jqXHR.readyState == 0 || jqXHR.status == 0) {
				return;
			} else {
				alert('something went wrong');
			}
		})
		.always(function() {
			table.removeClass('ajax-loading');
		});

	}
	
	function handleScrolltoSection(){

		$('html').on('click', '.trigger-scoll-to-section', function (e) {

			e.preventDefault();
			var target = $(this).attr('data-target');
			scrollToElement($('.' + target), 0);

		});

		if($('.scroll-to-section').length){
			var target = $('.scroll-to-section').attr('data-section');
			scrollToElement($('#' + target), 0);
		}
	}

	function handleHeader(){
		var $header = $('#header');
		var $trigger = $('#hero');
		if($('.single-post').length){
			$trigger = $('.panel-section.section-content');
		}
		var $window = $(window);
		$window.on('load resize scroll', function () {
			var scroll = $(this).scrollTop();
			var triggerPoint = ($trigger.offset().top + $trigger.height()) * 1;
			// $header.toggleClass('small', scroll > triggerPoint);
			$header.toggleClass('small', scroll > 250);
		});
	}

	function handleCarousels(){
	
		if($('.homepage-carousel').length){
			$('.homepage-carousel .owl-carousel').owlCarousel({
				items: 1,
				responsiveRefreshRate: 0,
				loop: true,
				// autoplay: true,
				autoplayTimeout: 7000,
				autoplaySpeed: 500,
				dotsSpeed: 500,
				dragEndSpeed: 500,
				onChanged: function(event){
					var el = $(event.target).find('.slide').eq(event.item.index).find('.text-container');
					var newone = el.clone(true).removeClass('aos-init aos-animate');
					newone.find('h1').removeClass('aos-init aos-animate');
					newone.find('a').removeClass('aos-init aos-animate');
 					el.before(newone);
 					el.remove();

					 AOS.refreshHard();
				}
			});
		}
		if($('.brand-carousel').length){
			$('.brand-carousel .owl-carousel').owlCarousel({
				items: 4,
				responsiveRefreshRate: 0,
				loop: true,
				autoplay: false,
				dotsSpeed: 500,
				dragEndSpeed: 500,
				margin: 25,
				nav: true,
				navContainer: '.brand-carousel .custom-nav',
				dots: false,
				responsive:{
					0:{
						items:1,
					},
					768:{
						items:2,
					},
					991:{
						items:4,
					}
				}
			});
		}
		if($('.brands-list-carousel').length){
			$('.brands-list-carousel .owl-carousel').owlCarousel({
				items: 4,
				responsiveRefreshRate: 0,
				loop: true,
				autoplay: false,
				dotsSpeed: 500,
				dragEndSpeed: 500,
				margin: 25,
				nav: true,
				navContainer: '.brands-list-carousel .custom-nav',
				dots: false,
				responsive:{
					0:{
						items:1,
					},
					768:{
						items:2,
					},
					991:{
						items:4,
					}
				}
			});
		}

	}

	function handleScrollDownLinks()
	{

		// var lastSectionLink = false;
		//
		// $( ".panel-section" ).each(function( index ) {
		// 	var currentPanelSection = $(this);
		// 	if (lastSectionLink)
		// 	{
		// 		lastSectionLink.click(function (e) {
		// 			scrollToElement( currentPanelSection, 0 );
		// 		});
		// 	}
		// 	lastSectionLink = $( "<span class='nextsection'>More</span>" );
		// 	$( this ).append( lastSectionLink );
		// });

		// $('html').on('click', '.nextsection', function (e) {
		// 	scrollToElement( $('#section-attunga-capital'), 0 );
		// });

	}

	function handleFadeInElements()
	{

		const inViewport = (entries, observer) => {
			entries.forEach(entry => {
				entry.target.classList.toggle("is-inViewport", entry.isIntersecting);
			});
		};

		const Obs = new IntersectionObserver(inViewport);
		const obsOptions = {}; //See: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API#Intersection_observer_options

// Attach observer to every [data-inviewport] element:
		const ELs_inViewport = document.querySelectorAll('.btn');
		ELs_inViewport.forEach(EL => {
			Obs.observe(EL, obsOptions);
		});


	}
	function handlePageScroll(a,b,c)
	{

		var $header = $('#header');

		$header.toggleClass('small', !($(a).hasClass('section-hero')));

		if ($(a).find('.brand-carousel .owl-carousel').length) {
			if (!animate) {
				$(".brand-carousel .owl-carousel").trigger('play.owl.autoplay');
				animate = true;
				// console.log('Starting animation');
			}
		}else{
			if (animate) {
				$(".brand-carousel .owl-carousel").trigger('stop.owl.autoplay');
				animate = false;
				// console.log('Stopping animation');
			}
		}
	}

	function handleFullPage()
	{
		$(document).ready(function () {
			if (($('body.home').length > 0) && ($("#main").fullView))
			{
				$("#main").fullView( {onScrollEnd:handlePageScroll});
			}
		});
	}

	function scrollToElement(element, offset) {
		if (element.length) {

			var headerHeight = $('header').outerHeight();
			var bannerHeight = 0;

			// if($('#banner').length){
			// 	bannerHeight = $('#banner').outerHeight();
			// }

			$('html, body').animate({
				scrollTop: (element.first().offset().top - headerHeight - bannerHeight - offset)
			}, 300);
		}
	}

	AOS.init();
	$('img[usemap]').rwdImageMaps();

});

if(navigator.platform.match('Mac') !== null) {
	document.body.classList.add('OSX');
}